module.exports = __webpack_public_path__ + "img/the-factory-bloc.ecdcbf8d.jpg";